import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import orcidService from "./orcidService";

interface orcidState {
    orcid: string | null;
    loadingOrcid: boolean;
    actionLoading: boolean;
    actionSuccess: boolean;
    error: string | undefined | null;
}

const initialState: orcidState = {
  orcid: null,
  loadingOrcid: false,
  actionLoading: false,
  actionSuccess: false,
  error: null,
};

export const orcidLogin = createAsyncThunk<
  {url: string},
  void,
  { rejectValue: string }
>("orcid/login", async (_, thunkAPI) => {
  try {
    const res = await orcidService.login();
    return res;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const orcidLinkEmailThunk = createAsyncThunk<
  { message: string },
  { token: string; email: string },
  { rejectValue: string }
>("orcid/linkEmail", async ({ token, email }, thunkAPI) => {
  try {
    return await orcidService.linkEmail(token, email);
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.detail || error.message);
  }
});

export const orcidVerifyThunk = createAsyncThunk<
  { message: string; orcid: string },
  { token: string },
  { rejectValue: string }
>("orcid/verify", async ({ token }, thunkAPI) => {
  try {
    return await orcidService.verifyOrcid(token);
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.detail || error.message);
  }
});

const orcidSlice = createSlice({
  name: "orcid",
  initialState,
  reducers: {
    resetOrcidActionState: (state) => {
      state.actionLoading = false;
      state.actionSuccess = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(orcidLogin.pending, (state) => {
        state.loadingOrcid = true;
        state.error = null;
      })
      .addCase(orcidLogin.fulfilled, (state) => {
        state.loadingOrcid = false;
        // Dependiendo de tu implementación de backend, aquí se guarda la url o los datos del usuario
      })
      .addCase(orcidLogin.rejected, (state, action) => {
        state.loadingOrcid = false;
        state.error = action.payload;
      })
      
      // Link Email
      .addCase(orcidLinkEmailThunk.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.actionSuccess = false;
      })
      .addCase(orcidLinkEmailThunk.fulfilled, (state) => {
        state.actionLoading = false;
        state.actionSuccess = true;
      })
      .addCase(orcidLinkEmailThunk.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      // Verify Final Link
      .addCase(orcidVerifyThunk.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.actionSuccess = false;
      })
      .addCase(orcidVerifyThunk.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.actionSuccess = true;
        state.orcid = action.payload.orcid;
      })
      .addCase(orcidVerifyThunk.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetOrcidActionState } = orcidSlice.actions;
export default orcidSlice.reducer;
